import { Link } from 'react-router-dom';
import { useI18n } from '../../contexts/I18nContext';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_1c07591d-63e3-4991-946f-f8a8e8c125c9/artifacts/i94v1fmk_IMG_0910.jpeg";

const Footer = () => {
  const { t } = useI18n();
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: 'Nosotros', path: '/nosotros' },
      { label: 'Servicios', path: '/servicios' },
      { label: 'Proyectos', path: '/proyectos' },
      { label: 'Contacto', path: '/contacto' },
    ],
    invest: [
      { label: 'Oportunidades', path: '/oportunidades' },
      { label: 'Cómo Funciona', path: '/como-funciona' },
      { label: 'Aportar Inmueble', path: '/aportar-inmueble' },
    ],
    legal: [
      { label: t('legal.terms'), path: '/legal/terms' },
      { label: t('legal.privacy'), path: '/legal/privacy' },
      { label: t('legal.riskDisclosures'), path: '/legal/risk-disclosures' },
    ],
  };

  return (
    <footer className="bg-card border-t border-border">
      <div className="container-app section-spacing">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={LOGO_URL} 
                alt="Silver Brick Development" 
                className="h-16 w-auto"
              />
            </Link>
            <p className="body-text text-sm max-w-xs">
              Inversión inmobiliaria blindada con disciplina, transparencia y compromiso.
            </p>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-foreground mb-6">
              Compañía
            </h4>
            <ul className="space-y-4">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Invest Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-foreground mb-6">
              Inversión
            </h4>
            <ul className="space-y-4">
              {footerLinks.invest.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-foreground mb-6">
              Legal
            </h4>
            <ul className="space-y-4">
              {footerLinks.legal.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Risk Disclaimer */}
        <div className="mt-16 pt-8 border-t border-border">
          <p className="text-xs text-muted-foreground/60 leading-relaxed max-w-4xl">
            {t('legal.riskWarning')} Esta información es únicamente para fines informativos y no constituye una oferta pública de valores donde esté prohibido. El acceso a ciertos materiales puede requerir verificación de identidad, revisión de idoneidad y aceptación legal. Silver Brick Development se reserva el derecho de aceptar o rechazar solicitudes de participación sujetas a revisión legal e interna.
          </p>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {currentYear} {t('footer.company')}. {t('footer.rights')}
          </p>
          <div className="flex items-center gap-6">
            <Link 
              to="/legal/terms" 
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              {t('legal.terms')}
            </Link>
            <Link 
              to="/legal/privacy" 
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              {t('legal.privacy')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
